import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const DownArrow = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="down-arrow"
    height={height}
    width={width}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 11L4.5359 7.25L11.4641 7.25L8 11Z" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
